(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lq-product-set"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lq-product-set')) {
    customElements.define('lq-product-set', class extends HTMLElement {
      connectedCallback() {
        if(this.dataset.ready) return;
        this.dataset.ready='true';
        const box=this, rows=Array.from(box.querySelectorAll('.lq-product-set-item'));
        const button=box.querySelector('.lq-product-set-add'), status=box.querySelector('.lq-product-set-status'), total=box.querySelector('.lq-product-set-total');
        const formatter=new Intl.NumberFormat(document.documentElement.lang||'es',{style:'currency',currency:box.dataset.currency||'EUR'});
        function update(){
          if(box.getAttribute('aria-busy')==='true')return;
          let sum=0,selected=0,complete=true;
          rows.forEach(row=>{
            const check=row.querySelector('input'),select=row.querySelector('select');
            select.disabled=!check.checked;
            if(check.checked){selected++;if(!select.value)complete=false;else sum+=Number(select.selectedOptions[0].dataset.price);}
            const img=row.querySelector('img'),src=select.selectedOptions[0]?.dataset.image;
            if(src&&img){img.src=src;img.removeAttribute('srcset');}
          });
          total.textContent=complete?formatter.format(sum/100):'—';
          button.disabled=!selected||!complete;
          status.textContent=!selected?box.dataset.none:!complete?box.dataset.incomplete:selected+' '+box.dataset.selected;
        }
        box.addEventListener('change',update);update();
        button.addEventListener('click',async()=>{
          if(button.disabled)return;
          const items=rows.filter(row=>row.querySelector('input').checked).map(row=>({id:row.querySelector('select').value,quantity:1}));
          button.disabled=true;box.setAttribute('aria-busy','true');status.textContent=box.dataset.adding;
          let added=false;
          try {
            const root=box.dataset.root.replace(/\/$/,'')+'/';
            const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
            const result=await response.json();
            if(!response.ok)throw new Error(result.description||box.dataset.failed);
            added=true;status.textContent=box.dataset.added;window.location.assign(root+'cart');
          } catch(error){status.textContent=error.message+' '+box.dataset.review;}
          finally {box.removeAttribute('aria-busy');if(!added)button.disabled=false;}
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
